import { NgFor, NgIf, CommonModule, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation, forwardRef } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute, Router, RouterLink, RouterOutlet } from '@angular/router';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { FileManagerComponent } from 'app/modules/admin/apps/file-manager/file-manager.component';
import { FileManagerService } from 'app/modules/admin/apps/file-manager/file-manager.service';
import { Item, Items, ItemPagination, ItemLabel, BaseListReponse, assetsFilterFields, AssetsSearch, SortingPreference } from 'app/modules/admin/apps/file-manager/file-manager.types';
import { Observable, Subject, takeUntil } from 'rxjs';
import { SearchComponent, SearchConfig } from 'app/layout/common/search/search.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule, MatRippleModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { fuseAnimations } from '@fuse/animations';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { HttpClientModule } from "@angular/common/http";
import { MatTableModule } from '@angular/material/table';
import { iconTypes } from 'app/modules/admin/apps/file-manager/file-manager.constants';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { FuseFindByKeyPipe } from '@fuse/pipes/find-by-key/find-by-key.pipe';
import { labelColorDefs } from 'app/modules/admin/apps/file-manager/file-manager.constants';
import { MatExpansionModule, MatExpansionPanel } from '@angular/material/expansion';
import { DocumentService } from 'app/services/document.service';
import { EventService } from 'app/services/event.service';
import { Asset, AssetPathItem } from 'app/models/document';
import { ScrollingModule } from '@angular/cdk/scrolling';
import * as consts from 'app/shared/global-constants';
import { Util } from 'app/models/util';
import { FuseLoadingBarComponent } from '@fuse/components/loading-bar';
import { FuseScrollbarDirective } from '@fuse/directives/scrollbar';
import { DataVisualBarTrashComponent } from '../data-visuals/dv-bar-trash/dv-bar-trash.component';
import { LabelService } from 'app/services/label.service';
import { FilterComponent } from '../filter/filter.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { FileSizePipe } from '@fuse/pipes/file-size.pipe';
import { Title } from '@angular/platform-browser';
import { LpmConfig } from 'app/models/lpm.config';
import { NgxLoadingModule } from 'ngx-loading';
import { Label } from 'app/models/label';
import { CUSTOM_THEME_ELEMENTS_CLASSES } from 'app/constants';
import { IsDisplayedDirective } from "@fuse/directives/isDisplayed.directive";
import { LpmLabelPipe } from '@fuse/pipes/lpm-label.pipe';
import { FullNamePipe, getFullName } from '@fuse/pipes/full-name.pipe';

@Component({
    selector: 'file-manager-trash',
    templateUrl: './trash.component.html',
    styleUrls: ['./trash.component.scss'],
    encapsulation: ViewEncapsulation.None,
    // changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        MatSidenavModule,
        NgIf,
        RouterLink,
        NgFor,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        MatCheckboxModule,
        MatOptionModule,
        MatRippleModule,
        MatFormFieldModule,
        MatInputModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatSortModule,
        HttpClientModule,
        MatTableModule,
        MatMenuModule,
        CommonModule,
        MatExpansionModule,
        ScrollingModule,
        FuseLoadingBarComponent,
        DataVisualBarTrashComponent,
        FilterComponent,
        OverlayModule,
        FileSizePipe,
        NgxLoadingModule,
        SearchComponent,
        forwardRef(() => IsDisplayedDirective),
        forwardRef(() => LpmLabelPipe),
        FullNamePipe
    ],
    // providers : [FileManagerComponent]
})

export class FileManagerTrashComponent implements OnInit, OnDestroy {
    @Input() defaultView: string = null;
    @Input() lpm: LpmConfig = new LpmConfig();
    pageLimitList = consts.pagelimits;

    selectedItem: Item;
    parentItem: Item;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    labelColors: any;
    labels: Label[] = [];
    viewMode: any;

    @ViewChild(MatPaginator) private _paginator: MatPaginator;
    @ViewChild(MatSort) private _sort: MatSort;
    pagination: ItemPagination;
    isLoading: boolean = false;
    isSearching: boolean = false;
    searchConfig: SearchConfig = {
        emitKeywords: true,
        placeholder: 'Search Trash',
        showTrashFilter: false,
        requireFileName: false,
    };
    isWebComponent: boolean = this.util.getIsWebApp();
    isStatsPanelOpen = false;
    iconTypes: any = iconTypes;

    // we create an object that contains coordinates 
    menuTopLeftPosition = { x: 0, y: 0 };

    // reference to the MatMenuTrigger in the DOM 
    @ViewChild('fmItemActionMenuItemTrigger', { static: true }) matMenuTrigger!: MatMenuTrigger;
    @ViewChild('filterPanel', { static: true }) filterPanel: MatExpansionPanel;
    @ViewChild('multiItemSelectPanel', { static: true }) multiItemSelectPanel: MatExpansionPanel;
    @ViewChild('statsPanel', { static: true }) statsPanel: MatExpansionPanel;

    selectedRows: Asset[] = [];
    lastSelectedIndex: number = -1;

    page: ItemPagination = new ItemPagination();

    folders: Asset[] = [];
    files: Asset[] = [];
    items: Asset[] = [];
    totalAssets: { files: number; folders: number } = { files: 0, folders: 0 }

    total = 0;
    radius: number;
    color: string;
    searchQuery: string = ""
    assetsFilterFields: assetsFilterFields = new assetsFilterFields()
    assetsSearch: AssetsSearch = new AssetsSearch()
    assetPaths: { [key: string]: AssetPathItem[] } = {};
    hoveredAssetId: string = ""
    isBreadCrumbOpen: boolean = false
    teamDecorator = {};
    itemDecoratorComplete: boolean = false;
    isAllRowsSelected:boolean = false;

    /**
     * Constructor
     */
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        public _fileManagerComponent: FileManagerComponent,
        private _fileManagerService: FileManagerService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        public docService: DocumentService,
        public eventSer: EventService,
        public util: Util,
        private labelService: LabelService,
        private titleService: Title,
        private labelPipe: LpmLabelPipe
    ) {
        const trashLabel = this.labelPipe.transform('Trash', 'trashLocationLabel');
        this.titleService.setTitle(`DMS - ${trashLabel}`);
        this.searchConfig = { ...this.searchConfig, placeholder: `Search ${trashLabel}` };
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this.page.size = Number(this.util.getPageLimit());
        this.assetsSearch.status = "TRASH"
        // Latest updated on top
        this.assetsSearch.sortColumn = 'UPDATED_DATE';
        this.assetsSearch.sortDirection = 'DESCENDING';
        this.eventSer.getTrashData.subscribe((data) => {
            this.getTrashData();

        })
        // Set the defaults
        //this._fileManagerService.registerIcons();

        // TODO - set viewMode default based on user preference
        this.getTrashData();
        this.viewMode = this._fileManagerService.viewMode;
        console.log("onInit - " + this.viewMode);

        // Get the label colors
        this.labelColors = labelColorDefs;

        //this.matDrawer.open ? '(min-width: 1280px)' : '(min-width: 1800px)'
        this._fuseMediaWatcherService.onMediaQueryChange$('(min-width: 1800px)')
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((state) => {

                // Mark for check
                this._changeDetectorRef.markForCheck();
            });

        this._fileManagerService.registerIcons();

        // Get the pagination
        this._fileManagerService.pagination$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((pagination: ItemPagination) => {
                // Update the pagination
                this.pagination = pagination;

                // Mark for check
                this._changeDetectorRef.markForCheck();
            });

        this.assetsFilterFields.label = false;
        this.labelColors = labelColorDefs;
        this.getLabels();
    }

    getLabels() {
        this.labelService.getLabels().then((res) => {
            this.labels = this.labelService.getSimData(res);
        }).catch((error) => {
            console.log(error);
        })
    }

    onPageChanged(e: PageEvent) {
        this.page.length = e.length;
        this.page.size = e.pageSize;
        this.page.page = e.pageIndex;
        this.util.setPageLimit(this.page.size);
        this.getTrashData();
    }

    async getTrashData(keepList: boolean = false) {
        // Keep list visible while searching
        this.isSearching = keepList;
        this.isLoading = !keepList;
        this.page.trash = true;
        this.resetSelectedRows();
        if (!keepList) this.items = []
        this.docService.getAssets(this.page, this.assetsSearch).then((res) => {
            this.items = this.docService.getData(res);
            const meta = this.docService.getMeta(res);
            this.selectedRows = []
            this.selectedItem = null
            this.total = meta.total;
            this.totalAssets.files = meta.totalFiles //FIMME
            this.totalAssets.folders = meta.totalFolders//FIMME
            //this.setPath(this.items);
            if (this.items && this.items.length > 0) {
                this.folders = this.items.filter((item) => item.type === 'FOLDER');
                this.files = this.items.filter((item) => item.type === 'FILE');
            }
            else {
                this.folders = []
                this.files = []
            }
            this.isLoading = false;
            this.isSearching = false;
            this.renderTeamMembers();
        }).catch((err) => {
            this.isLoading = false;
            this.isSearching = false;
            console.log(err.message)
        })
        this._changeDetectorRef.markForCheck();
    }

    sortData(sort: Sort) {
        this.page.orderOn = sort.active;
        this.assetsSearch.sortDirection = this.util.getSortDirection(sort.direction)
        const sortPrefernce: SortingPreference = { viewName: 'Trashed', sort }
        this.util.setSortingPreference(sortPrefernce)
        this.assetsSearch.sortColumn = sort.active as any
        this.getTrashData();

    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * On backdrop clicked
     */
    onBackdropClicked(): void {
        // Go back to the list
        this._router.navigate(['./'], { relativeTo: this._activatedRoute });

        // Mark for check
        this._changeDetectorRef.markForCheck();
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }

    /*
    *  View details of the main parent folder in current folder
    */
    viewDetails(): void {
        const routerPath = this._activatedRoute.snapshot.url.join('/');
        //console.log(routerPath);
        const currentFolderId = routerPath.split('/').pop();
        const parentFolderId = this._fileManagerService.getItemById(currentFolderId);
        if (parentFolderId) {
            console.log(parentFolderId);
        }

        if (currentFolderId) {
            //console.log(currentFolderId);
            this._router.navigate(['apps/file-manager/folders/' + currentFolderId + '/details/' + currentFolderId]);
        } else {
            console.log('is root');
        }
    }

    /**
     * Toggle the viewMode between 'grid' and 'cards'
     *
     * @param viewMode
     */
    toggleViewMode(): void {
        this._fileManagerService.viewMode = this._fileManagerService.viewMode === 'grid' ? 'cards' : 'grid';
        this.viewMode = this._fileManagerService.viewMode;
    }

    /** 
     * Method called when the user click with the right button 
     * @param event MouseEvent, it contains the coordinates 
     * @param item Our data contained in the row of the table 
     */
    onRightClick(event: MouseEvent, selectedItem: Asset, type?: string): void {

        // preventDefault avoids to show the visualization of the right-click menu of the browser 
        event.preventDefault();

        // we record the mouse position in our object 
        this.menuTopLeftPosition.x = event.clientX;
        this.menuTopLeftPosition.y = event.clientY;

        // we open the menu 
        // we pass to the menu the information about our object 
        this.matMenuTrigger.menuData = { item: selectedItem };

        // we open the menu 
        this.matMenuTrigger.openMenu();
    }

    /**
     * Toggle the filterPanel open and close
     */
    toggleFilterPanel(): void {
        // toggle the filterPanel open and close
        this.filterPanel.toggle();
        // TODO - clear the filters on close

        //if opening the filterPanel, close the multiItemSelectPanel
        if (this.filterPanel.opened) {
            this.selectedRows = [];
            this.multiItemSelectPanel.close();
        }

        //TODO - if filter panel is open and then user makes a parameter selection, 
        //close multiItemSelectPanel and clear selectedRows.
    }

    /**
     * Toggle the statsPanel open and close
     */
    toggleStatsPanel(): void {
        // toggle the panel open and close
        console.log('toggleStatsPanel');
        this.statsPanel.toggle();
        // TODO - clear the filters on close 
    }

    /**
     * 
     * @param item 
     * Select rows by clicking on the available row space
     */
    onSelect(file: Asset, index: number, event: MouseEvent) {
        const isSelected = this.selectedRows.some(selectedFile => selectedFile.id === file.id);
        if (event.shiftKey && this.lastSelectedIndex !== -1) {

            if (isSelected) {
                // Deselect the row if it's already selected
                this.selectedRows = this.selectedRows.filter(selectedFile => selectedFile.id !== file.id);
            } else {
                // For multiple selection, add the current selection
                this.selectedRows = [...this.selectedRows, file];
                this.lastSelectedIndex = index; // Update last selected index for future shift selections
            }
        } else {

            if (isSelected) {
                // Deselect the row if it's already selected
                this.selectedRows = this.selectedRows.filter(selectedFile => selectedFile.id !== file.id);
            } else {
                // For single selection, replace the current selection
                this.selectedRows = [file];
                this.lastSelectedIndex = index; // Update last selected index for future shift selections
            }
        }

        // Panel visibility logic remains the same
        if (this.selectedRows.length > 0) {
            this.multiItemSelectPanel.open();
        } else {
            this.multiItemSelectPanel.close();
        }

        // Log the current selection for debugging
        console.log(`Selected rows:`, this.selectedRows.map(item => item.id));
    }

    // Helper function to check if a row is selected
    isSelected(file: any): boolean {
        return this.selectedRows.some(selectedFile => selectedFile.id === file.id);
    }

    cancelBulkAction(): void {
        this.selectedRows = [];
        this.multiItemSelectPanel.close();
        this.isAllRowsSelected = false;
    }

    delete(id: string): void {
        this._fileManagerComponent.openDialog_delete(id);
    }

    delete_multi(assetId): void {
        let assetIds: string[] = []
        assetIds = this.selectedRows.length ? this.selectedRows.map((x) => x.id) : [assetId];
        if (this.selectedRows.length) this._fileManagerComponent.openDialog_delete_multi(assetIds);
        else this._fileManagerComponent.openDialog_delete(assetIds[0]);
    }

    delete_all(): void {
        this._fileManagerService.openDialog_delete_all();
    }

    restore(id: string): void {
        this._fileManagerService.openDialog_restore(id);
    }

    restore_multi(): void {
        if (this.selectedRows && this.selectedRows.length === 1) {
            this.restore(this.selectedRows[0].id);
        } else {
            const ids: string[] = this.selectedRows.map(row => row.id)
            this._fileManagerService.openDialog_restore_multi(ids);
        }
    }

    viewStats(): void {
        //TODO - display stats for the trash
    }

    stopPropagation(event: MouseEvent): void {
        this._fileManagerComponent.stopPropagation(event);
    }

    onFilterChange(event) {
        // Keep typed search keyword
        this.assetsSearch = { ...event, keywords: this.assetsSearch.keywords };

        this.assetsSearch.sortColumn = 'UPDATED_DATE';
        this.assetsSearch.sortDirection = 'DESCENDING';
        this.getTrashData();
    }

    onSearchKeywords(keywords: string): void {
        this.assetsSearch.keywords = keywords;
        this.page.page = 0;
        this.getTrashData(true);
    }

    // Advanced search, scoped to trash
    onSearchApplied(search: AssetsSearch): void {
        this.assetsSearch = { ...search, status: 'TRASH', sortColumn: 'UPDATED_DATE', sortDirection: 'DESCENDING' };
        this.page.page = 0;
        this.getTrashData(true);
    }

    loadTooltipText(assetId: string) {
        this.isBreadCrumbOpen = true
        this.hoveredAssetId = assetId
        if (!this.assetPaths[assetId]) {
            this.docService.getAssetFullPath(assetId).subscribe(path => {
                this.assetPaths[assetId] = this.util.scopePathToRoot(path as any);
            });
        }
    }

    getParentLink(id: string) {
        const rootLink = this.util.getRootFromSession()
        return rootLink == id ? ['/apps/file-manager/'] : ['/apps/file-manager/folders/', id];
    }

    hideBreadCrumb() {
        this.isBreadCrumbOpen = false
    }

    renderTeamMembers() {
        this.items.forEach((asset: Asset) => {
            asset["innerDiv"] = "";

            if (asset.createdBy.profilePic) {
                asset["innerDiv"] += `<img
                class="shrink-0 w-10 h-10 mr-4 rounded-full overflow-hidden object-cover object-center"
                src="${asset.createdBy.profilePic}"
                [alt]="'Activity image'">`;
            } else {
                const name = getFullName(asset.createdBy).toUpperCase();
                const dec_class = this.util.getUserColor(name);
                const [first, last] = name.split(" ");

                const initials = `${first?.substring(0, 1) || ''}${last?.substring(0, 1) || ''}`;
                this.teamDecorator[name] = initials;
                
                asset["innerDiv"]       += ` <div class=" ${dec_class} flex shrink-0 items-center justify-center w-10 h-10 mr-4 rounded-full font-10">
                    ${this.teamDecorator[name]}
                </div>`;
            }
        });
        this.itemDecoratorComplete = true;
    }

    toggleCheckAll():void {

        this.isAllRowsSelected = !this.isAllRowsSelected;

        if (this.isAllRowsSelected) {
            this.selectedRows = this.items;
        }
        if (!this.isAllRowsSelected) {
            this.selectedRows = [];
        }

        this.toggleMultiRowSelectedOptions()
    }

    toggleRowCheck(checked: boolean, asset: Asset = null):void {

        if (checked) {
            this.selectedRows.push(asset)
        } else {
            this.selectedRows = this.selectedRows.filter(row => row.id !== asset.id);
        }

        this.isAllRowsSelected = this.selectedRows.length === this.items.length;

        this.toggleMultiRowSelectedOptions()

    }

    resetSelectedRows():void {
        this.selectedRows = [];
        this.isAllRowsSelected = false;
        this.multiItemSelectPanel.close();
    }

    isSelectedRow(asset: Asset):boolean {
        return this.selectedRows.some(item => item.id === asset.id)
    }

    isFolderRowSelected():boolean {
        const index = this.selectedRows.findIndex(row => row.type == 'FOLDER')
        return index !== -1

    }

    toggleMultiRowSelectedOptions():void {
        if (this.selectedRows.length > 0) {
            this.multiItemSelectPanel.open();
        } else {
            this.multiItemSelectPanel.close();
        }
    }

    onRowClick(file:Asset){
        const isSelected = this.isSelectedRow(file);
        this.toggleRowCheck(!isSelected, file);
    }

}
